// Handle Trusted Shops widget visibility when chat is open on mobile
document.addEventListener('DOMContentLoaded', function() {
  // Debug logging function
  const enableDebugging = false;
  
  const debug = (message) => {
    if (enableDebugging) {
      console.log(`[Trusted Shops Debug] ${message}`);
    }
  };

  // Function to check if device is mobile
  const isMobile = () => window.innerWidth <= 768;

  // Function to hide Trusted Shops widget
  const hideTrustedShopsWidget = () => {
    const trustedShopsWidget = document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810');
    if (trustedShopsWidget) {
      trustedShopsWidget.style.display = 'none';
      debug('Widget hidden');
    } else {
      debug('Widget not found with ID: trustbadge-container-98e3dadd90eb493088abdc5597a70810');
    }
  };

  // Function to show Trusted Shops widget
  const showTrustedShopsWidget = () => {
    const trustedShopsWidget = document.querySelector('#trustbadge-container-98e3dadd90eb493088abdc5597a70810');
    if (trustedShopsWidget) {
      trustedShopsWidget.style.display = 'block';
      debug('Widget shown');
    } else {
      debug('Widget not found with ID: trustbadge-container-98e3dadd90eb493088abdc5597a70810');
    }
  };

  // Function to check if Shopify Inbox is open
  const isShopifyInboxOpen = () => {
    const shopifyInboxFrame = document.querySelector('iframe[data-inbox-container]');
    const shopifyInboxContainer = document.querySelector('[data-inbox-container]');
    
    debug(`Inbox Frame found: ${!!shopifyInboxFrame}`);
    debug(`Inbox Container found: ${!!shopifyInboxContainer}`);
    
    if (shopifyInboxContainer) {
      debug(`Container aria-hidden: ${shopifyInboxContainer.getAttribute('aria-hidden')}`);
      debug(`Container classes: ${shopifyInboxContainer.className}`);
    }
    
    const isOpen = shopifyInboxFrame && shopifyInboxContainer && 
           (shopifyInboxContainer.getAttribute('aria-hidden') === 'false' || 
            shopifyInboxContainer.classList.contains('_active'));
            
    debug(`Inbox is ${isOpen ? 'open' : 'closed'}`);
    return isOpen;
  };

  // Create a MutationObserver to watch for chat window changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        debug(`Mutation detected: ${mutation.type}`);
        if (mutation.type === 'attributes') {
          debug(`Changed attribute: ${mutation.attributeName}`);
        }
        
        if (isMobile()) {
          debug('Device is mobile');
          if (isShopifyInboxOpen()) {
            hideTrustedShopsWidget();
          } else {
            showTrustedShopsWidget();
          }
        } else {
          debug('Device is desktop');
        }
      }
    });
  });

  // Start observing the body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden']
  });
  debug('Observer started');

  // Handle window resize
  window.addEventListener('resize', () => {
    debug(`Window resized. Width: ${window.innerWidth}`);
    if (isMobile() && isShopifyInboxOpen()) {
      hideTrustedShopsWidget();
    } else {
      showTrustedShopsWidget();
    }
  });

  // Initial check
  debug('Performing initial check');
  if (isMobile()) {
    debug('Initially on mobile');
    if (isShopifyInboxOpen()) {
      debug('Inbox initially open');
      hideTrustedShopsWidget();
    } else {
      debug('Inbox initially closed');
      showTrustedShopsWidget();
    }
  } else {
    debug('Initially on desktop');
  }
});